import React from "react";
import Head from "next/head";
import Page_name from "../../components/pagename/index";
import Contact_us from "../../components/contact_us";
import axios from "../../Axios/index";
import { useTranslations } from "next-intl";
import EmployeeCard from "../../components/about_us/EmployeeCard";

function our_team({ allTeam }) {
  const t = useTranslations("Team");
  const result = allTeam.map((element) => {
    return <EmployeeCard element={element} />;
  });

  return (
    <div>
      <Head>
        <title>Ascot Team | Ascot Enterprise Solutions</title>
      </Head>
      <Page_name title={t("pagename")} img={"ourteam/Star"} />
      <div className="max-w-[90rem] w-[90%] m-auto ">
        <div className=" mt-[41px] ">
          <p className=" font-[400] text-[16px] leading-[26px] text-[#010140]">
            {t("title")}
          </p>
        </div>

        <div className="flex flex-wrap justify-center responsive mt-6 gap-5">
          {result}
        </div>
      </div>
      <Contact_us />
    </div>
  );
}

export default our_team;

export async function getServerSideProps({ locale }) {
  try {
    const { data } = await axios.get(`user/team/all-team`);
    const allTeam = data.result.sort((a, b) => a.index - b.index);
    return {
      props: {
        allTeam,
        messages: require(`../../locales/${locale || "en"}.json`),
      },
    };
  } catch (error) {}
}
